import request from '../../axios';

export const addComments = async (payload: IAddComments) => {
  await request.post(`/api/v2/store/store-comment`, {
    ...payload,
  });
};
